import { FC } from 'react';
import { Outlet } from 'react-router-dom';

import { ResaleUserProvider } from '../../hooks/contexts/resale-user.context';
import { ResaleProvider } from '../../hooks/contexts/resale.context';
import { ResaleEventProvider } from '../../hooks/contexts/resaleEvent.context';
import { FastPassOfferProvider } from '../../providers/FastPassOfferProvider';
import FixedBarTheme from '../Header/AppBar/FixedBarTheme';
import ResaleAppBar from '../Header/ResaleAppBar';
import * as Style from './layout.styles';

/**
 * Layout dedicated to resale routes (/resale/:resaleId and /resale/:resaleId/payment)
 *
 * Scopes resale-specific providers so they are only initialized when
 * the user accesses a resale page, keeping the global provider tree clean.
 *
 * Note: global Providers (I18n, User, Modal, etc.) are provided by the parent
 * tree in RoutesApp — this component only adds the resale-specific providers.
 *
 * FastPassOfferProvider envolve todo o layout para que ResaleAppBar,
 * ResalePage e ResalePaymentPage compartilhem uma UNICA resolucao da oferta
 * (1 fetch por jornada em vez de 4).
 */
const ResaleLayout: FC = () => {
  return (
    <ResaleProvider>
      <ResaleUserProvider>
        <ResaleEventProvider>
          <FastPassOfferProvider>
            <Style.Layout id="layout-app" data-testid="layout-app">
              <Style.Header id="header-app" data-testid="header-app">
                <FixedBarTheme />
                <Style.Container>
                  <ResaleAppBar />
                </Style.Container>
              </Style.Header>
              <Style.Container>
                <Style.ContainerChild>
                  <Outlet />
                </Style.ContainerChild>
              </Style.Container>
            </Style.Layout>
          </FastPassOfferProvider>
        </ResaleEventProvider>
      </ResaleUserProvider>
    </ResaleProvider>
  );
};

export default ResaleLayout;
